module.exports = __webpack_public_path__ + "img/manual-holiday-03-delete-holiday.31b665ce.png";